import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountBalanceApi } from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

export const fetchAccountBalance = createAsyncThunk(
  "accountBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      let accType = "";
      if (filters?.filterType === "Cash Wise") accType = "'cash_in_hand'";
      else if (filters?.filterType === "Bank account Wise")
        accType = "'bank_account'";
      else accType = "'cash_in_hand','bank_account'";

      const payload = {
        accId: filters?.accId || null,
        accType,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate ? `${filters.toDate} 23:59:59` : null,
      };

      const res = await getAccountBalanceApi(payload);

      const list = res.data.accounts || [];
      const totals = {
        opening: list.reduce((s, r) => s + Number(r.opening_balance || 0), 0),
        debit: list.reduce((s, r) => s + Number(r.received_total || 0), 0),
        credit: list.reduce((s, r) => s + Number(r.payment_total || 0), 0),
        balance: Number(res.data.total_balance || 0),
      };

      return { list, totals };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchBankAccountsBySearch = createAsyncThunk(
  "accountBalance/fetchBankAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["bank_account"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCashAccountsBySearch = createAsyncThunk(
  "accountBalance/fetchCashAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["cash_in_hand"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);